<template>
  <form @submit.prevent="promiseSendMessage = sendMessage()">
  <b-modal ref="modal"
           title="Test Connection"
           @hide="clearData">

    <div v-show="showErrorMessage" class="alert alert-danger alert-dismissible" role="alert">
      <strong>Failed to send message. </strong>See <router-link v-if="channelId" :to="{ name: 'administration.channel-detail.logs', params: {id: this.channelId}}" active-class="active" >Logs</router-link> for details.
      <button type="button" class="close" aria-label="Close" @click="hideError">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-warning" role="alert">
      <strong>Warning!</strong> Test connection sends real message to given phone number. SMS costs will be charged by the provider.
    </div>

      <div class="form-group">
        <label for="phone-number-input">Phone Number (including country code):</label>
        <input class="form-control w-50"
               :class="{'is-invalid': isPhoneNumberInvalid}"
               id="phone-number-input"
               placeholder="+1 (555) 857-6309"
               v-model.trim="phoneNumber">
        <div v-show="isPhoneNumberInvalid" class="invalid-feedback">
          Please provide a phone number.
        </div>
        <label for="message-text-input" class="mt-2">Message:</label>
        <textarea class="form-control"
                  id="message-text-input"
                  rows="3"
                  v-model.trim="messageText"
                  :placeholder="defaultMessageText"
                  maxlength="1377"></textarea>
      </div>

    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click="hide">Cancel</button>
      <!-- "Ladda button" breaks disabling button -->
      <button type="submit" class="mr-0 btn btn-success"
              v-busy-button="promiseSendMessage">
        Send SMS
      </button>
    </template>

  </b-modal>
  </form>
</template>

<script>
  import notificationService from '@/services/notification/notification.service'
  import messageService from '@/services/amio-api/message.service'

  export default {
    props: {
      channelId: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        messageText: '',
        phoneNumber: '',
        isPhoneNumberInvalid: false,
        promiseSendMessage: null,
        showErrorMessage: false,
        defaultMessageText: 'Amio greets you on mobile. Looks like all settings were done correctly. Let\'s build something amazing!'
      }
    },

    methods: {
      show() {
        this.$refs.modal.show()
      },
      hide() {
        this.clearData()
        this.$refs.modal.hide()
      },

      clearData() {
        this.messageText = ''
        this.phoneNumber = ''
        this.promiseSendMessage = null
      },

      sendMessage() {
        if (!this.checkFormErrors()) return

        this.hideError()

        return messageService.sendMessage({
          channel: {id: this.channelId},
          contact: {phone_number: this.phoneNumber},
          content: {
            type: 'text',
            payload: (this.messageText || this.defaultMessageText)
          },
          metadata: {
            amio_test_message: true
          }
        })
          .then(() => {
            notificationService.success('Message sent')
            this.hide()
          })
          .catch(() => {
            this.showErrorMessage = true
            this.promiseSendMessage = null
          })
      },

      checkFormErrors() {
        this.isPhoneNumberInvalid = false

        if (!this.phoneNumber) {
          this.isPhoneNumberInvalid = true
        }

        return !this.isPhoneNumberInvalid
      },

      hideError() {
        this.showErrorMessage = false
      }

    }
  }
</script>
